import {useState} from 'react';
import styled from 'styled-components';
import {Color} from '../../tokens/colors';
import {OrderName} from '../order-name/order-name';
import {TaskSwitches} from '../task-switches/task-switches';
import {TaskItem} from '../task-item/task-item';
import {InfoBlock} from '../info-block/info-block';

const Title = styled.h1`
    font-size: 20px;
    font-weight: 400;
    line-height: 24px;
    margin: 30px 0 50px;
    color: black;
`;

const StyledItemContainer = styled.li`
    &&& {
        margin: 0;
        padding-top: 8px;
        padding-bottom: 8px;
        padding-left: 0;

        &:first-child {
            padding-top: 0;
        }

        &:last-child {
            padding-bottom: 0;
        }

        &::before {
            content: none;
        }
    }
`;

const StyledList = styled.ul`
    &&& {
        margin: 0;
        padding: 0;
        list-style: none;
        max-width: 658px;
    }
`;

const StyledPanel = styled.div`
    position: relative;
    padding: 18px 24px 18px 52px;
    background-color: ${Color.BLOCK_GRAY};

    @media (max-width: 767px) {
        padding: 15px 42px 15px 15px;
    }
`;

const StyledHeader = styled.div`
    display: flex;
    align-items: flex-start;

    @media (max-width: 767px) {
        flex-direction: column;
    }
`;

const OrderItem = ({order}) => {
    const getFirstTaskNumber = (tasks) => {
        if (tasks) {
            const [firstTask] = tasks;

            return firstTask.number || 0;
        }

        return 0;
    };

    const [activeTaskNumber, setActiveTaskNumber] = useState(getFirstTaskNumber(order.tasks));

    if (Object.keys(order).length === 0) {
        return null;
    }

    return (
        <>
            <Title>Производственные заказы</Title>
            <StyledList>
                <StyledItemContainer>
                    <StyledPanel>
                        <StyledHeader>
                            <OrderName number={order.number} name={order.name} />
                        </StyledHeader>
                        <TaskSwitches
                            tasks={order.tasks}
                            activeNumber={activeTaskNumber}
                            onSwitchClick={setActiveTaskNumber}
                        />
                    </StyledPanel>

                    {order.tasks
                        ? order.tasks.map((task) => {
                              return (
                                  <TaskItem
                                      key={task.number}
                                      isActive={task.number === activeTaskNumber}
                                      task={task}
                                      userNames={order.user.names}
                                  />
                              );
                          })
                        : null}
                </StyledItemContainer>
            </StyledList>
            <InfoBlock />
        </>
    );
};

export {OrderItem};
